import { hotjar } from 'react-hotjar';

const initializeHotjar = () => {
  const hjid = 3143037;
  const hjsv = 6;
  if (process) {
    const NODE_ENV = process.env.NODE_ENV;
    if (NODE_ENV === 'production') {
      hotjar.initialize(hjid, hjsv);
    }
  }
};

export default initializeHotjar;
